import { usePatient } from '@hook'
import { BinIcon } from '@icons'
import { Button, ModalHeader } from '@ui'
import { getError, showToast } from '@util'
import { Box, Heading, Layer, Text } from 'grommet'
import { Checkmark, Close } from 'grommet-icons'
import { useState } from 'react'

type Props = {
  onClose: () => void
  id?: string
}

export const RemovePatient = ({ onClose, id }: Props) => {
  const [loading, setLoading] = useState(false)
  const { deletePatient } = usePatient()

  const handleSubmit = async () => {
    setLoading(true)
    try {
      await deletePatient(id || '')
      showToast('Patient deleted Successfully')
      setLoading(false)
    } catch (err) {
      getError(err)
      setLoading(false)
    }
    onClose()
  }
  return (
    <Layer modal onClickOutside={onClose} onEsc={onClose} position="center" style={{ borderRadius: '15px' }}>
      <Box align="center" justify="center" pad="medium" width="430px">
        <ModalHeader onClose={onClose} pad="0" />
        <Box align="center" justify="center" margin={{ bottom: 'small' }}>
          <BinIcon />
        </Box>
        <Box gap="small" margin={{ bottom: 'small' }} width="281px">
          <Heading color="black" level={5} margin="medium" size="20px" textAlign="center" weight="400">
            Confirm you want to remove this patient
          </Heading>
          <Text color={'#999999'} margin="small" size="14px" textAlign="center">
            The patient&apos;s record and history will be wiped off the system
          </Text>
        </Box>
        <Box
          direction="row"
          flex
          gap="16px"
          justify="center"
          pad={{ horizontal: '32px', vertical: '14px' }}
          width="100%"
        >
          <Button
            color="#F5F5F5"
            icon={<Close size="small" />}
            kinds="secondary"
            label="Cancel"
            onClick={() => onClose()}
            size={'wide'}
            style={{ color: 'black', fontSize: '16px', fontWeight: '500' }}
          />
          <Button
            icon={<Checkmark size="small" />}
            isLoading={loading}
            label="Remove"
            onClick={handleSubmit}
            size={'wide'}
            style={{ fontSize: '16px', fontWeight: '500' }}
          />
        </Box>
      </Box>
    </Layer>
  )
}
